import { render } from "./Item.vue?vue&type=template&id=1abe1d9a&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=1abe1d9a&scoped=true&lang=css"

import exportComponent from "C:\\Com\\officialServe-vue\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abe1d9a"]])

export default __exports__